@if (isLoading()) {
<div class="u-spacing-xl-mt">
    @for (_ of skeletonCount; track $index) {
    <ce-skeleton-loader class="u-size-md-h u-spacing-sm-mv" />
    }
</div>
} @else {
<ul ce-level-menu class="SidePanel-menu" [data]="navigationList()" [expandFirstLevel]="true"></ul>
}
